import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTasyarBrand } from '../lib/tasyarBrand';

export default function PublicVenuesHeader() {
  const navigate = useNavigate();
  const brand = useTasyarBrand();
  return (
    <header className="fixed inset-x-0 top-0 z-30 border-b border-teal-900/30 bg-[#0A192F]/90 backdrop-blur-xl" data-testid="venues-public-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-5 py-4">
        <button onClick={() => navigate('/')} className="flex min-w-0 items-center gap-2" data-testid="venues-public-home-btn">
          {brand.iconUrl ? (
            <img src={brand.iconUrl} alt={brand.name} className="h-8 w-8 shrink-0 rounded-lg object-contain" />
          ) : (
            <span className="h-8 w-8 shrink-0 rounded-lg bg-teal-500/20" />
          )}
          <span className="truncate font-display text-lg font-black text-white">{brand.name}</span>
          <span className="hidden text-slate-500 sm:inline"> / تسيار الملاعب</span>
        </button>
        <div className="flex items-center gap-3">
          <button onClick={() => navigate('/login')} className="text-sm font-semibold text-slate-300 hover:text-white" data-testid="venues-public-login-btn">تسجيل الدخول</button>
          <button onClick={() => navigate('/register')} className="rounded-full bg-gradient-to-l from-orange-500 to-orange-400 px-5 py-2 text-sm font-bold text-white shadow-[0_0_15px_rgba(245,76,7,0.4)]" data-testid="venues-public-cta-btn">
            ابدأ مجانًا
          </button>
        </div>
      </div>
    </header>
  );
}
